import classNames from 'classnames';
import React, { useEffect } from 'react';

import ChartDefaults from './ChartDefaults';

//
// Chart
//

interface ChartProps {
  layout?: string;
  size?: string;
  className?: string;
  children?: React.ReactNode;
}

function Chart({ layout, size, className, ...props }: ChartProps) {
  const classes = classNames('chart', layout && `chart-${layout}`, size && `chart-${size}`, className);

  useEffect(function () {
    ChartDefaults();

    return function () {
      const tooltip = document.getElementById('chart-tooltip');

      if (tooltip) {
        tooltip.parentNode?.removeChild(tooltip);
      }
    };
  }, []);

  return <div className={classes} {...props} />;
}

//
// Chart legend
//

interface ChartLegendProps {
  data: {
    labels: string[];
    datasets: { backgroundColor: string[] }[];
  };
  className?: string;
}

function ChartLegend({ data, className, ...props }: ChartLegendProps) {
  const classes = classNames('chart-legend', className);

  const items = data.labels.map(function (label: string, index: number) {
    const color = data.datasets[0].backgroundColor[index];

    return <ChartLegendItem color={color} label={label} key={index} />;
  });

  return (
    <div className={classes} {...props}>
      {items}
    </div>
  );
}

//
// Chart legend item
//

function ChartLegendItem({ color, label }: { color: string; label: string }) {
  return (
    <div className="chart-legend-item">
      <ChartLegendIndicator color={color} /> {label}
    </div>
  );
}

//
// Chart legend indicator
//

function ChartLegendIndicator({ color }: { color: string }) {
  return <i className="chart-legend-indicator" style={{ backgroundColor: color }} />;
}

export { Chart, ChartLegend };
